import { TooltipIcon, TOOLTIP_ICON } from './components';
import { TOOLTIP_CONST, type TooltipProps } from './Tooltip.d';
import { useTooltip } from './Tooltip.hooks';
import { Tooltip } from './Tooltip.styles';

const TooltipBase = ({
  align,
  children,
  content,
  customIcon = TOOLTIP_ICON.INFO,
  direction,
  label = '',
  withIcon = false,
  isPdp = false,
  openInHover = false,
}: TooltipProps) => {
  const {
    baseRef,
    containerRef,
    handleOnClick,
    handleVisibility,
    isVisible,
    positionX,
    positionY,
    tooltipRef,
  } = useTooltip(align, direction);

  const onClickFunction = () => (label ? { onClick: handleOnClick(label) } : {});

  const onMouseFunction = () => {
    if (openInHover) {
      handleVisibility();
    }
  };

  return (
    <Tooltip.Component
      ref={containerRef}
      aria-hidden={!isVisible}
      data-testid={TOOLTIP_CONST.TEST_ID}
      data-pdp={isPdp}
      onClick={onClickFunction}
    >
      {isPdp ? (
        <Tooltip.Content
          ref={tooltipRef}
          aria-describedby="tooltip-open"
          data-align={positionX}
          data-composed={withIcon}
          data-direction={positionY}
          data-testid="tooltip-content"
          data-pdp={isPdp}
          data-pdp-visible={isVisible}
        >
          {withIcon && <TooltipIcon icon={customIcon} />}
          <Tooltip.ContentText variant="auxiliar-small">{content}</Tooltip.ContentText>
        </Tooltip.Content>
      ) : (
        <>
          {isVisible && (
            <Tooltip.Content
              ref={tooltipRef}
              aria-describedby="tooltip-open"
              data-align={positionX}
              data-composed={withIcon}
              data-direction={positionY}
              data-testid="tooltip-content"
              data-pdp={isPdp}
            >
              {withIcon && <TooltipIcon icon={customIcon} />}
              <Tooltip.ContentText variant="auxiliar-small">{content}</Tooltip.ContentText>
            </Tooltip.Content>
          )}
        </>
      )}

      <Tooltip.Wrapper
        ref={baseRef}
        data-direction={positionY}
        data-testid="tooltip-base"
        data-pdp-visible={isVisible}
        data-visible-pdp={isVisible}
        data-pdp={isPdp}
        id="tooltip-open"
        onClick={handleVisibility}
        onMouseEnter={onMouseFunction}
        onMouseLeave={onMouseFunction}
      >
        {children}
      </Tooltip.Wrapper>
    </Tooltip.Component>
  );
};

export default TooltipBase;
